export default __webpack_public_path__ + "static/media/configure.bc308591.png";